import React from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {useFormik} from 'formik'
import {initVoucherFormValues, IVoucherFormValuesType} from '../_model'
import ReactSelectBox from '../../../../utils/components/ReactSelectBox'
import useInvoiceList from '../../../../hooks/useInvoiceList'
import * as Yup from 'yup'
import {BASE_URL} from '../../../config'
import {useMutation, useQueryClient} from 'react-query'
import axios from 'axios'
import toast from 'react-hot-toast'

const CREATE_VOUCHER_URL = `${BASE_URL}/api/protect/createReceiptVoucher`

const voucherFormSchema = Yup.object().shape({
  invoice: Yup.string().required('Select invoice'),
  amount: Yup.number()
    .typeError('Enter a valid amount')
    .required('Enter amount')
    .moreThan(0, 'Amount must be greater than 0'),
})

const VoucherForm = () => {
  const queryClient = useQueryClient()
  const {invoices} = useInvoiceList()

  const formik = useFormik<IVoucherFormValuesType>({
    initialValues: initVoucherFormValues,
    validationSchema: voucherFormSchema,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        const {invoiceId, amount} = values
        await createVoucher({invoiceId, amount})
        console.log(values)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const {mutateAsync: createVoucher} = useMutation({
    mutationFn: async (sendValues: Partial<IVoucherFormValuesType>) => {
      const {invoiceId, amount} = sendValues
      const res = await axios.post(CREATE_VOUCHER_URL, null, {
        params: {
          invoiceId,
          amount,
        },
      })

      const data = await res.data
      return data.message
    },

    onSuccess: (values) => {
      toast.dismiss()
      toast.success(values || 'Successfull')
      queryClient.invalidateQueries(['voucherList'])
      resetForm()
    },
  })

  const resetForm = () => {
    formik.resetForm()
  }

  const onSelectInvoice = (id: number) => formik.setFieldValue('invoiceId', id)

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Voucher Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Invoice</label>

                <ReactSelectBox
                  placeholder='Select invoice'
                  options={invoices}
                  formik={formik}
                  fieldValue='invoice'
                  setSelect={onSelectInvoice}
                />

                {formik.touched.invoice && formik.errors.invoice && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.invoice}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Amount</label>

                <input
                  {...formik.getFieldProps('amount')}
                  placeholder='Enter amount'
                  type='text'
                  className='form-control form-control custom-input mb-3 mb-lg-0'
                  autoComplete='off'
                />

                {formik.touched.amount && formik.errors.amount && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.amount}</span>
                    </div>
                  </div>
                )}
              </div>

              <div className='text-center pt-15'>
                <button
                  type='reset'
                  className='btn btn-light me-3 border border-gray-600'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  CLOSE
                </button>

                <button
                  type='submit'
                  className='btn btn-primary me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VoucherForm
